$(document).on('input', 'input#resend-verification-email-input', function(){
  // TODO: When this file is refactored to use ES modules, replace this inline regex
  // with the shared validator from app/javascript/utils/email-validator.js
  let EMAIL_VALIDATION_REGEX = /^[\w+\-\=.']+@[a-z\d\-]+(\.[a-z\d\-]+)*\.[a-z]{2,15}$/i;
  if(this.value.length > 0) {
    $("#resend-email-error-msg").show();
  }

  if(this.value.length > 0 && EMAIL_VALIDATION_REGEX.test(this.value)) {
    $("#resend-email-error-msg").hide();
    $('#resend-verification-email-submit').removeAttr('disabled');
  }

  if(this.value.length === 0) {
    $('#resend-verification-email-submit').attr('disabled', true)
  }
});
